import { useZodForm } from '../../../hooks/useZodForm.js';
import { schNewForm, schRecommendCompsForm } from '../schemas.js';
import { InitialCompSearch } from '../types.js';

export const useRecommendedCompsForm = (defaultValues: InitialCompSearch['body']) =>
  useZodForm({
    schema: schRecommendCompsForm,
    defaultValues: schNewForm.parse(defaultValues),
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });
